import { Card, CardContent, Typography } from "@mui/material";
import { AnalyticsPanel } from "./AnalyticsVisuals";
import { LocalShippingOutlined } from "@mui/icons-material";

interface VehicleAnalyticsProps {
  data?: any;
}

const VehicleAnalytics = ({ data }: VehicleAnalyticsProps) => {
  return (
    <AnalyticsPanel title="Vehicle Analytics" icon={<LocalShippingOutlined />}>
        <Typography variant="body2" color="text.secondary" sx={{ p: 2, bgcolor: "action.hover", borderRadius: 2, minHeight: 125, overflowWrap: "anywhere", lineHeight: 1.8 }}>
          {data ? JSON.stringify(data) : "Vehicle analytics will appear after vehicle-service metrics are connected."}
        </Typography>
    </AnalyticsPanel>
  );
};

export default VehicleAnalytics;
